import storage from './storage';

/**
 * Dispensa do guia de apresentação da Clara.
 *
 * Guardamos a DATA em que cada usuário marcou "não ver novamente hoje", e não
 * um booleano: assim a dispensa expira sozinha na virada do dia, sem nenhuma
 * rotina de limpeza. O mapa é por usuário porque a máquina pode ser
 * compartilhada — quem nunca viu o guia precisa vê-lo.
 */
const CLARA_GUIDE_STORAGE_KEY = 'clara-guide-tc';

const getCurrentUserId = () => {
  try {
    const user = storage.getUserOnStorage();

    return user?.id || null;
  } catch (error) {
    return null;
  }
};

const currentDay = () => {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');

  return `${now.getFullYear()}-${month}-${day}`;
};

const readAll = () => {
  try {
    const stored = localStorage.getItem(CLARA_GUIDE_STORAGE_KEY);

    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    return {};
  }
};

export const wasDismissedToday = () => {
  const userId = getCurrentUserId();

  if (!userId) {
    return false;
  }

  return readAll()[userId] === currentDay();
};

export const dismissForToday = () => {
  const userId = getCurrentUserId();

  if (!userId) {
    return;
  }

  try {
    const all = readAll();

    all[userId] = currentDay();
    localStorage.setItem(CLARA_GUIDE_STORAGE_KEY, JSON.stringify(all));
  } catch (error) {
    /* Sem localStorage o guia apenas volta a aparecer no próximo login. */
  }
};

export default {
  wasDismissedToday,
  dismissForToday
};
